import React from 'react'
import { Form } from 'semantic-ui-react'

export default class BankAccNumber extends React.PureComponent {
  render() {
    const { value, onChange, required } = this.props

    return (
      <Form.Input
        fluid
        required={required}
        label="ABA Account Number"
        placeholder="e.g 000 333 444"
        onChange={e => onChange('aba_account_number', e.target.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/bankAccountNumberField.js